import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const INITIAL_STATE = {
  isFlowActive: false,
  payoutAccountType: null,
  currentStep: 1,
  withdrawalAmount: null,
  selectedPayoutAccountId: null,
  transactionFee: null,
  exciseDuty: null,
  totalAmount: null,
  transactionId: null,
  otpSentTo: null,
  confirmationMode: null,
  status: null,
  createdDate: null,
  newBalance: null,
  remarks: null,
  otpAuthorizationSubmitted: false,
};

const useFundsTransferStore = create(
  persist(
    (set) => ({
      ...INITIAL_STATE,
      activateFlow: () => set({ isFlowActive: true }),
      deactivateFlow: () => set({ isFlowActive: false }),
      setPayoutAccountType: (payoutAccountType) => set({ payoutAccountType }),
      setCurrentStep: (currentStep) => set({ currentStep }),
      setWithdrawalDraft: ({ withdrawalAmount, selectedPayoutAccountId }) =>
        set({ withdrawalAmount, selectedPayoutAccountId }),
      setWithdrawalCharges: ({ transactionFee, exciseDuty, totalAmount, newBalance }) =>
        set({ transactionFee, exciseDuty, totalAmount, newBalance }),
      setWithdrawalInitiation: ({ transactionId, otpSentTo, confirmationMode }) =>
        set({
          transactionId,
          otpSentTo,
          confirmationMode,
          selectedPayoutAccountId: null,
          newBalance: null,
        }),
      setDisbursementResult: ({ status, createdDate, newBalance, remarks }) =>
        set({ status, createdDate, newBalance, remarks: remarks ?? null }),
      setWithdrawalFailed: (remarks) => set({ remarks }),
      setOtpAuthorizationSubmitted: (otpAuthorizationSubmitted) =>
        set({ otpAuthorizationSubmitted }),
      reset: () => set(INITIAL_STATE),
    }),
    {
      name: "funds-transfer-store",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        isFlowActive: state.isFlowActive,
        payoutAccountType: state.payoutAccountType,
        currentStep: state.currentStep,
        withdrawalAmount: state.withdrawalAmount,
        selectedPayoutAccountId: state.selectedPayoutAccountId,
        transactionFee: state.transactionFee,
        exciseDuty: state.exciseDuty,
        totalAmount: state.totalAmount,
        transactionId: state.transactionId,
        otpSentTo: state.otpSentTo,
        confirmationMode: state.confirmationMode,
        status: state.status,
        createdDate: state.createdDate,
        newBalance: state.newBalance,
        remarks: state.remarks,
        otpAuthorizationSubmitted: state.otpAuthorizationSubmitted,
      }),
    },
  ),
);

export default useFundsTransferStore;
